import { Box, Divider } from '@wix/design-system'
import React, { FC, memo, ReactElement } from 'react'

import { BackButton } from '../BackButton'
import { commonLogoWithBackDataHooks as dataHooks } from './CommonLogoWithBack.dataHooks'

type Skin = 'dark' | 'light'

export type CommonLogoWithBackProps = {
  backButton?: string | null
  onBackClick?: () => void
  dataHook?: string
  skin?: Skin
  logo: ReactElement
}

export const CommonLogoWithBack: FC<CommonLogoWithBackProps> = memo(
  ({ backButton, onBackClick, dataHook, skin = 'dark', logo }) => (
    <Box
      height="42px"
      verticalAlign="middle"
      gap="18px"
      position="absolute"
      left="36px"
      top="36px"
      zIndex="999"
      dataHook={dataHook}
    >
      {logo}
      {backButton && (
        <>
          <Divider direction="vertical" />
          <BackButton text={backButton} onClick={onBackClick} skin={skin} dataHook={dataHooks.backBtn()} />
        </>
      )}
    </Box>
  ),
)
